export default function () {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7109_11721)">
                <path
                    d="M31.148 6.75H4.85203C4.14457 6.75 3.66081 7.46453 3.92356 8.12139L5.625 12.375H30.375L32.0764 8.12139C32.3392 7.46453 31.8554 6.75 31.148 6.75Z"
                    stroke="#3EAE60"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M32.625 18H3.375L5.625 12.375H30.375L32.625 18Z" stroke="#3EAE60" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M32.625 18H3.375V27.75C3.375 28.5784 4.04657 29.25 4.875 29.25H31.125C31.9534 29.25 32.625 28.5784 32.625 27.75V18Z"
                    stroke="#3EAE60"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M9 20.8125V26.4375" stroke="#3EAE60" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6.57031 22.2188L11.4417 25.0312" stroke="#3EAE60" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6.57031 25.0278L11.4306 22.2217" stroke="#3EAE60" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7.3125 21.6562L7.73438 22.9219L6.46875 23.2031" stroke="#3EAE60" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6.46875 24.0469L7.73438 24.3281L7.3125 25.5938" stroke="#3EAE60" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M10.6875 21.6562L10.2656 22.9219L11.5312 23.2031" stroke="#3EAE60" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11.5312 24.0469L10.2656 24.3281L10.6875 25.5938" stroke="#3EAE60" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8.15625 21.2344L9 22.0781L9.84375 21.2344" stroke="#3EAE60" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8.15625 26.0156L9 25.1719L9.84375 26.0156" stroke="#3EAE60" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M16.875 7.875H19.875" stroke="#3EAE60" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_7109_11721">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
